import { useAuthContext } from "@/core/contexts/AuthContext";

/**
 * Hook público de autenticação. Páginas e componentes devem usar este hook,
 * nunca importar AuthContext diretamente — mantém a camada Hooks como
 * intermediária única entre UI e o restante da arquitetura.
 */
export function useAuth() {
  const {
    session,
    pessoa,
    ehAdminPlataforma,
    podeGerenciarBiblioteca,
    podeGerenciarEventos,
    podeGerenciarReservas,
    podeAprovarReservas,
    modulosVisiveis,
    carregando,
    erroCarregamento,
    login,
    logout,
    recarregarAcessos,
    tentarNovamente,
  } = useAuthContext();

  return {
    estaAutenticado: !!session,
    usuario: session?.user ?? null,
    /** Pessoa do Núcleo (tabela `pessoas`) — fonte única de identidade desde a Fase 6. */
    pessoa,
    /** Nível 1 (DA-002). */
    ehAdminPlataforma,
    /** Nível 2 (DA-002), módulo Biblioteca. */
    podeGerenciarBiblioteca,
    /** Nível 2 (DA-002), módulo Eventos (Sprint 3). */
    podeGerenciarEventos,
    /** Nível 2 (DA-002), módulo Reservas (Sprint 3). */
    podeGerenciarReservas,
    /** Admin OU líder/gestor de algum ministério vinculado a Reservas — aprova pendentes (migration 0029). */
    podeAprovarReservas,
    /** Nível 1 OU Nível 2 — usado para decidir navegação para a área administrativa (etapa 4.4). */
    temAcessoAdministrativo: ehAdminPlataforma || podeGerenciarBiblioteca,
    /** G6: códigos dos módulos visíveis no menu para esta pessoa (visibilidade ≠ permissão). */
    modulosVisiveis,
    carregando,
    /** Preenchido quando o bootstrap trava/falha (BUG-08) — usar para oferecer "Tentar novamente". */
    erroCarregamento,
    login,
    logout,
    /** Recarrega os portões de acesso sem relogar (ex.: após aceitar convite). */
    recarregarAcessos,
    /** Refaz o bootstrap do zero após erroCarregamento, sem exigir F5 (BUG-08). */
    tentarNovamente,
  };
}
